export default __webpack_public_path__ + "static/media/phone.0910caa3.png";